export default {
  orgs: {
    ordering: 'alphabetical',
    status: null,
    data: [],
    page: 1,
    limit: 20,
    next: null,
  },
  currentOrgId: null,
  currentOrg: null,
  loadingCreateOrg: false,
  errorCreateOrg: false,
};
